module.exports = __webpack_public_path__ + "img/Taiwan-3.0742ebeb.jpg";